<template>
  <section id="mainContainer">
    <userHeader></userHeader>
    <section class="mid-container">
      <div class="team-page">
        <section class="team-top-section"
          :style="{ 'background-image': `url(${require('@/assets/images/team-banner-img.jpg')})` }">
          <div class="container">
            <h1>{{ constants['TEAM_TEXT'] }}</h1>
            <div class="claim-your-space">
              <i>
                <img src="@/assets/images/default-pic.png" alt="" />
                <strong>{{ constants['CLAIM_YOUR_SPACE_LABEL'] }}</strong>
              </i>
              <button data-bs-toggle="modal" data-bs-target="#joinUs">{{ constants['JOIN_US_BUTTON'] }}</button>
            </div>
          </div>
        </section>
        <section class="team-btm-section">
          <div class="container">
            <div class="team-btm--inner">
              <div class="team-member-box" data-bs-toggle="modal" data-bs-target="#teamMembers"
                v-for="(teamMember, index) in displayedTeamData" :key="index"
                @click="openTeamMemberModal(teamMember, index)">
                <div class="team-member--img">
                  <img :src="getCdnImageAddress(teamMember.teamMemberImage, `w_255,h_360/`)" alt="" />
                </div>
                <div class="team-member--content">
                  <h3>{{ teamMember.name }}</h3>
                  <span>{{ teamMember.designation }}</span>
                </div>
              </div>
            </div>
            <div class="load-more" v-if="displayedTeamData.length < ourTeamData.length">
              <button id="loadMoreBtn" class="primary-btn-outline" @click="loadMore">Load More</button>
            </div>
          </div>
        </section>
      </div>
    </section>
    <div class="modal fade" id="teamMembers" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog teamMember__modal" role="document" v-if="selectedTeamMember">
        <div class="modal-content">
          <div class="teammember_modal__inner">
            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
              <img src="@/assets/images/close-black-icon.svg" alt="" />
            </button>
            <div class="teammember__details">
              <div class="teammember__img">
                <img :src="getCdnImageAddress(selectedTeamMember.teamMemberImage, `w_255,h_360/`)" alt="" />
              </div>
              <div class="teammember__content">
                <div class="teammember__info">
                  <h2>{{ selectedTeamMember.name }}</h2>
                  <span>{{ selectedTeamMember.designation }}</span>
                </div>
                <div class="teammember__des" ref="scrollWrapper" data-simplebar>
                  <p v-html="selectedTeamMember.description"></p>
                </div>
              </div>
            </div>
            <div class="member-pagination">
              <div class="prev_member" v-if="prevMember">
                <button class="pagination-btns"
                  @click="openTeamMemberModal(prevMember, (currentIndex - 1 + ourTeamData.length) % ourTeamData.length)">
                  <div class="member_pagi_img">
                    <img :src="getCdnImageAddress(prevMember.teamMemberImage, `w_45,h_55/`) " alt="" />
                  </div>
                  <div class="member_pagi_info">
                    <strong>{{ prevMember.name }} </strong>
                    <span>{{ prevMember.designation }}</span>
                  </div>
                </button>
              </div>
              <div class="next_member" v-if="nextMember">
                <button class="pagination-btns"
                  @click="openTeamMemberModal(nextMember, (currentIndex + 1) % ourTeamData.length)">
                  <div class="member_pagi_info">
                    <strong>{{ nextMember.name }}</strong>
                    <span>{{ nextMember.designation }}</span>
                  </div>
                  <div class="member_pagi_img">
                    <img :src="getCdnImageAddress(nextMember.teamMemberImage, `w_45,h_55/`) " alt="" />
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <jobForm></jobForm>
    <userFooter></userFooter>
    <ChatbotPopup></ChatbotPopup>
  </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import userHeader from "@/components/userHeader.vue";
import userFooter from "@/components/userFooter.vue";
import jobForm from "@/components/jobForm.vue";
import axios from 'axios';
import SimpleBar from 'simplebar';
import constants from '@/utils/en-US-User.json';
import { environment } from '@/config/environment';
import { API_BASE_URL } from '@/config/api.config';
import ChatbotPopup from '@/components/chatbotPopup.vue';

interface OurTeam {
  id: number;
  name: string;
  email: string;
  designation: string;
  description: string;
  teamMemberImage: string
}
export default defineComponent({
  name: "our-team",

  components: {
    userHeader,
    userFooter,
    jobForm,
    ChatbotPopup
  },
  data() {
    return {
      constants,
      ourTeamData: [] as OurTeam[],
      selectedTeamMember: {} as OurTeam,
      currentIndex: -1,
      itemsToShow: 8,
      displayedTeamData: [] as OurTeam[],

    };
  },
  computed: {
    prevMember(): OurTeam | null {
      if (this.currentIndex === -1 || this.ourTeamData.length === 0) return null;
      const prevIndex = (this.currentIndex - 1 + this.ourTeamData.length) % this.ourTeamData.length;
      return this.ourTeamData[prevIndex];
    },
    nextMember(): OurTeam | null {
      if (this.currentIndex === -1 || this.ourTeamData.length === 0) return null;
      const nextIndex = (this.currentIndex + 1) % this.ourTeamData.length;
      return this.ourTeamData[nextIndex];
    },
  },
  created() {
    this.fetchTeamMembers()
  },
  mounted() {
    const el = this.$refs.scrollWrapper as HTMLElement;
    if (el) {
      new SimpleBar(el);
    };
  },
  methods: {
    async fetchTeamMembers() {
      try {
        const response = await axios.get(`${API_BASE_URL}/teammember/?status=1`)
        this.ourTeamData = response.data;
        this.displayedTeamData = this.ourTeamData.slice(0, this.itemsToShow);
      } catch (error) {
        console.error(Error)
      }
    },
    openTeamMemberModal(teamMember: OurTeam, index: number) {
      this.selectedTeamMember = teamMember;
      this.currentIndex = index;
    },
    loadMore() {
      const nextBatch = this.displayedTeamData.length + this.itemsToShow;
      this.displayedTeamData = this.ourTeamData.slice(0, nextBatch);
    },
    getCdnImageAddress(src: string, size: string): string {
        if (!src) return '';
        let cdnUrl: string = environment.imageCdn.getHost;
        cdnUrl = cdnUrl.concat(size);
        return cdnUrl + encodeURIComponent(src);
    }
  }
});
</script>